module.exports = __webpack_public_path__ + "img/15.fbff6997.jpg";